module.exports = __webpack_public_path__ + "static/media/HA outcome.8e4c8bfb.png";